/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddLootBoxPrizeBody
 */
export interface AddLootBoxPrizeBody {
    /**
     * 
     * @type {string}
     * @memberof AddLootBoxPrizeBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddLootBoxPrizeBody
     */
    rewardConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof AddLootBoxPrizeBody
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof AddLootBoxPrizeBody
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof AddLootBoxPrizeBody
     */
    sortOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof AddLootBoxPrizeBody
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof AddLootBoxPrizeBody
     */
    image?: string;
}

/**
 * Check if a given object implements the AddLootBoxPrizeBody interface.
 */
export function instanceOfAddLootBoxPrizeBody(value: object): value is AddLootBoxPrizeBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rewardConfigId' in value) || value['rewardConfigId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function AddLootBoxPrizeBodyFromJSON(json: any): AddLootBoxPrizeBody {
    return AddLootBoxPrizeBodyFromJSONTyped(json, false);
}

export function AddLootBoxPrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddLootBoxPrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'rewardConfigId': json['rewardConfigId'],
        'quantity': json['quantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}

export function AddLootBoxPrizeBodyToJSON(json: any): AddLootBoxPrizeBody {
    return AddLootBoxPrizeBodyToJSONTyped(json, false);
}

export function AddLootBoxPrizeBodyToJSONTyped(value?: AddLootBoxPrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'rewardConfigId': value['rewardConfigId'],
        'quantity': value['quantity'],
        'weight': value['weight'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'image': value['image'],
    };
}

